@if (mediaQueryService.breakpoints$ | async; as breakpoints) {
  <div
    [ngClass]="{ error: error, edit: editMode, 'side-panel': sidePanel }"
    class="phones-edit-wrapper"
    data-test-id="phones-edit-container"
  >
    @if (!editMode && !sidePanel) {
      <div>
        <div class="phones-edit-values">
          <span [ngClass]="{ empty: !phones.MobilePhone }" class="phone-label subheading">Mobile phone</span>
        </div>
        <div class="flex flex-between-stretch">
          <span
            [ngClass]="{ placeholder: !phones.MobilePhone }"
            class="phone-value mobileNumber"
            data-test-id="phones-edit-mobileNumber-value"
          >
            {{ phones.MobilePhone || 'e.g. +48 555 444 333' }}
          </span>
          @if (!readonly && canEdit) {
            <button
              (click)="activate()"
              class="small-button"
              color="primary"
              data-test-id="phones-edit-mobileNumber-add-edit-button"
              mat-button
            >
              {{ phones.MobilePhone ? 'Edit' : 'Add' }}
            </button>
          }
        </div>
        @if (phones.BusinessPhone) {
          <div class="business-number-wrapper">
            <div class="phones-edit-values">
              <span [ngClass]="{ empty: !phones.BusinessPhone }" class="phone-label subheading">Business phone</span>
            </div>
            @if (phones.BusinessPhone) {
              <span class="phone-value businessNumber" data-test-id="phones-edit-businessNumber-value">
                {{ phones.BusinessPhone }}
              </span>
            }
          </div>
        }
      </div>
    }

    @if (!editMode && sidePanel) {
      <div class="flex flex-col flex-start-stretch">
        <!-- Mobile phone -->
        <div class="phone-row row-border first-row flex flex-start-stretch">
          <div class="flex-data-wrapper">
            <div class="phone-label-container">
              <span [ngClass]="{ empty: !phones.MobilePhone }" class="phone-label">Mobile phone</span>
            </div>
            <div class="phone-value-container">
              @if (phones.MobilePhone) {
                <a
                  [href]="'tel:' + phones.MobilePhone?.trim() | trustedUrl"
                  class="phone-value"
                  data-test-id="phones-edit-sidepanel-mobileNumber-value"
                >
                  {{ phones.MobilePhone }}
                </a>
              }
              @if (!phones.MobilePhone && !readonly) {
                <span class="phone-value mobileNumber placeholder">e.g. +48 555 444 333</span>
              }
            </div>
          </div>
          <div class="actions">
            @if (!readonly && canEdit) {
              <button
                (click)="activate()"
                class="small-button"
                color="primary"
                data-test-id="phones-edit-sidepanel-mobileNumber-add-edit-button"
                mat-button
              >
                {{ phones.MobilePhone ? 'Edit' : 'Add' }}
              </button>
            }
          </div>
        </div>
        <!-- Business phone -->
        <div class="phone-row last-row flex flex-start-stretch">
          <div class="flex-data-wrapper">
            <div class="phone-label-container">
              <span [ngClass]="{ empty: !phones.BusinessPhone }" class="phone-label">Business phone</span>
            </div>
            <div class="phone-value-container">
              <a
                [href]="'tel:' + phones.BusinessPhone?.trim() | trustedUrl"
                class="phone-value"
                data-test-id="phones-edit-sidepanel-businessNumber-value"
              >
                {{ phones.BusinessPhone }}
              </a>
            </div>
          </div>
          <div class="actions">
            @if (!readonly && canEdit) {
              <button
                (click)="activate()"
                class="small-button"
                color="primary"
                data-test-id="phones-edit-sidepanel-businessNumber-add-edit-button"
                mat-button
              >
                {{ phones.BusinessPhone ? 'Edit' : 'Add' }}
              </button>
            }
          </div>
        </div>
      </div>
    }

    @if (editMode) {
      <div class="phones-edit-form-groups">
        <form
          [formGroup]="phonesEditForm"
          [ngClass]="{ loading: loading }"
          (keydown)="keyListener($event)"
          (keypress)="keyListener($event)"
          (ngSubmit)="update()"
          class="edit-form"
          data-test-id="phones-edit-form"
          name="phonesEditForm"
          novalidate
        >
          <h4 class="font-bold">Edit phone numbers</h4>
          <div class="content">
            <!-- cell phone -->
            <div class="control-container">
              <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
                <mat-label>Mobile phone</mat-label>
                <input
                  [maxlength]="MAX_LENGTHS_PHONE"
                  [minlength]="MIN_LENGTHS_PHONE"
                  data-test-id="phones-edit-form-mobileNumber-input"
                  formControlName="mobileNumber"
                  matInput
                  name="mobileNumber"
                  placeholder="Mobile phone"
                  type="text"
                />
              </mat-form-field>
              <validation-messages
                [field]="phonesEditForm.get('mobileNumber')"
                [messages]="['invalidPhone', 'required', 'minlength', 'maxlength']"
                [texts]="{
                  invalidPhone: 'Please enter a valid phone number.',
                  required: 'Please enter a phone number.',
                  minlength: `Phone number must be at least ${MIN_LENGTHS_PHONE} characters long.`,
                  maxlength: `Phone number cannot exceed ${MAX_LENGTHS_PHONE} characters.`,
                }"
                data-test-id="phones-edit-form-mobileNumber-validation"
              ></validation-messages>
            </div>

            <div class="control-container">
              <!-- business number -->
              <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
                <mat-label>Business phone (optional)</mat-label>
                <input
                  [maxlength]="MAX_LENGTHS_PHONE"
                  [minlength]="MIN_LENGTHS_PHONE"
                  data-test-id="phones-edit-form-businessNumber-input"
                  formControlName="businessNumber"
                  matInput
                  name="businessNumber"
                  placeholder="Business phone (optional)"
                  type="text"
                />
              </mat-form-field>
              <validation-messages
                [field]="phonesEditForm.get('businessNumber')"
                [messages]="['invalidPhone', 'minlength', 'maxlength']"
                [texts]="{
                  invalidPhone: 'Please enter a valid phone number.',
                  minlength: `Phone number must be at least ${MIN_LENGTHS_PHONE} characters long.`,
                  maxlength: `Phone number cannot exceed ${MAX_LENGTHS_PHONE} characters.`,
                }"
                data-test-id="phones-edit-form-businessNumber-validation"
              ></validation-messages>
            </div>
          </div>
          <div class="form-actions">
            <button
              [loading]="loading"
              class="small-button"
              color="primary"
              data-test-id="phones-edit-form-save-button"
              mat-stroked-button
              type="submit"
            >
              {{
                breakpoints.ltMd ? COMMON_BUTTONS_TEXTS.SAVE_CHANGES_MOBILE : COMMON_BUTTONS_TEXTS.SAVE_CHANGES_DESKTOP
              }}
            </button>
            <button
              (click)="reset()"
              class="small-button cancel-button"
              color="primary"
              data-test-id="phones-edit-form-discard-button"
              mat-button
              type="button"
            >
              {{
                breakpoints.ltMd
                  ? COMMON_BUTTONS_TEXTS.DISCARD_CHANGES_MOBILE
                  : COMMON_BUTTONS_TEXTS.DISCARD_CHANGES_DESKTOP
              }}
            </button>
          </div>
        </form>
      </div>
    }
  </div>
}
